import { Ng1StateDeclaration } from '@uirouter/angularjs';

const states: Ng1StateDeclaration[] = [
    {
        template: '<wt-alarms-management-state></wt-alarms-management-state>',
        name: 'alarmsManagement',
        url: '/alarmsManagement',
        data: {
            visible: false,
            displayName: 'Alarms management'
        }
    }];

export default states;